const brands = [
    { name: "Sunsama", description: "Daily digital planner" },
    { name: "SARAL", description: "Influencer management tool" },
    { name: "Kai", description: "AI digital assistant" },
    { name: "Nextiva", description: "AI receptionist" },
];

const BrandItem = ({ name, description }) => (
    <div className="flex-none flex items-center gap-3">
        <span className="font-display font-extrabold text-[20px] md:text-[22px] tracking-[-0.02em] text-[#0A0A0A] whitespace-nowrap">
            {name}
        </span>
        <span className="h-1 w-1 rounded-full bg-gray-300 flex-none" />
        <span className="text-[13px] md:text-sm text-gray-500 whitespace-nowrap">
            {description}
        </span>
    </div>
);

export const BrandTicker = () => {
    return (
        <section
            id="brands"
            data-testid="brand-ticker-section"
            className="py-10 md:py-12 bg-white border-t border-black/[0.06]"
        >
            <div className="container-page">
                <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-gray-500">
                    Brands I&apos;ve worked with
                </p>
                <div
                    data-testid="brand-ticker-track"
                    className="mt-6 flex flex-wrap items-center gap-x-10 gap-y-5 md:gap-x-16"
                >
                    {brands.map((b) => (
                        <BrandItem key={b.name} {...b} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BrandTicker;
